export default "__VITE_ASSET__lXb6EO7I__"